import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import { FocusScope } from '@react-aria/focus';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';

var renderOnPortal = function renderOnPortal(content, className) {
  return typeof window !== 'undefined' && typeof document !== 'undefined' && document.body ? /*#__PURE__*/ReactDOM.createPortal( /*#__PURE__*/React.createElement("div", {
    className: className
  }, content, /*#__PURE__*/React.createElement("div", {
    className: "tes-modal__backdrop"
  })), document.body) : null;
};

function TESModal(_ref) {
  var ChildComponent = _ref.children,
      showModal = _ref.showModal,
      onPortal = _ref.onPortal,
      onHideModal = _ref.onHideModal,
      title = _ref.title,
      modalType = _ref.modalType,
      size = _ref.size,
      className = _ref.className,
      portalClassName = _ref.portalClassName,
      lightOverlay = _ref.lightOverlay,
      isDismissible = _ref.isDismissible,
      theme = _ref.theme;
  var closeRef = useRef(null);
  useEffect(function () {
    if (typeof window !== 'undefined') {
      if (showModal) {
        document.body.classList.add('tes-modal--opened-container');

        if (isDismissible) {
          closeRef.current.focus();
        }
      } else {
        document.body.classList.remove('tes-modal--opened-container');
      }
    }
  }, [showModal]);
  var modalClassName = classNames('tes-modal', className, {
    'tes-modal--open': showModal,
    'tes-modal--info': modalType === 'info',
    'tes-modal--centered': modalType === 'centered'
  });
  var modalBackdropClassName = classNames('tes-modal__backdrop', {
    'tes-modal__backdrop--light': lightOverlay
  });
  var modalDialogClassName = classNames('tes-modal__dialog', _defineProperty({}, "tes-modal__dialog--".concat(size), size));
  var modalCloseClassName = classNames('tes-modal__close', _defineProperty({}, "tes-modal__close--color-".concat(theme), theme));

  var closeButton = function closeButton() {
    return /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: modalCloseClassName,
      "data-dismiss": "modal",
      "aria-label": "Close",
      onClick: onHideModal,
      ref: closeRef
    }, /*#__PURE__*/React.createElement("span", {
      className: "sr-only"
    }, "Close"));
  };

  var modalContent = function modalContent() {
    return (
      /*#__PURE__*/
      // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
      React.createElement("div", {
        className: modalClassName,
        id: "report-review-modal",
        tabIndex: "-1",
        role: "dialog",
        "aria-labelledby": "myModalLabel",
        onKeyDown: function onKeyDown(e) {
          if (!isDismissible) {
            return;
          }

          if (e.keyCode === 27) {
            // escape key maps to keycode `27`
            onHideModal();
          }
        }
      }, showModal ? /*#__PURE__*/React.createElement(FocusScope, {
        contain: true,
        restoreFocus: true
      }, /*#__PURE__*/React.createElement("div", {
        className: modalDialogClassName,
        role: "document"
      }, /*#__PURE__*/React.createElement("div", {
        className: "tes-modal__content"
      }, title ? /*#__PURE__*/React.createElement("h2", {
        className: "tes-modal__header"
      }, title, isDismissible && closeButton()) : isDismissible && closeButton(), /*#__PURE__*/React.createElement("div", {
        className: "tes-modal__body"
      }, ChildComponent)))) : null)
    );
  };

  return onPortal ? renderOnPortal(modalContent(), portalClassName) : /*#__PURE__*/React.createElement("div", null, modalContent(), /*#__PURE__*/React.createElement("div", {
    className: modalBackdropClassName
  }));
}

TESModal.propTypes = {
  children: PropTypes.element,
  onHideModal: PropTypes.func.isRequired,
  showModal: PropTypes.bool,
  onPortal: PropTypes.bool,
  title: PropTypes.string,
  modalType: PropTypes.string,
  size: PropTypes.oneOf(['sm', 'md', 'lg', 'xl']),
  className: PropTypes.string,
  portalClassName: PropTypes.string,
  lightOverlay: PropTypes.bool,
  isDismissible: PropTypes.bool,
  theme: PropTypes.string
};
TESModal.defaultProps = {
  className: '',
  onPortal: false,
  portalClassName: '',
  size: 'md',
  modalType: '',
  title: '',
  showModal: false,
  children: null,
  lightOverlay: false,
  isDismissible: true,
  theme: ''
};
export default TESModal;